
<svg class="xpinner"
     :class="[itemColor, newSpeed, newMode]"
     v-bind:width="size"
     v-bind:height="size"
     alt="Loading Spinner"
     viewBox="0 0 400 400"
     xmlns="http://www.w3.org/2000/svg">
  <circle v-if="hasBackground" class="bk" cx="200" cy="200" r="175" />
  <circle class="fill" cx="200" cy="200" r="175" />
</svg>
